import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import RegionAnalysisValid from './RegionAnalysisValid'
import RegionAnalysisInvalid from './RegionAnalysisInvalid'
import ProcessingTargetGroupAnalysisView from './ProcessingTargetGroupAnalysisView'

const RegionAnalysisView = ({ selectionStore, uiStore }) => (
  selectionStore.item.analysis.loading
    ? <ProcessingTargetGroupAnalysisView />
    : (
      <div className='analysis-container'>
        <div
          className={classnames({
            analysis: true,
            'analysis-without-chart': !uiStore.isBarChartActive,
            'analysis-with-chart': uiStore.isBarChartActive,

          })}
        >
          {
            selectionStore.item.analysis.valid
              ? <RegionAnalysisValid />
              : <RegionAnalysisInvalid />
          }
        </div>
      </div>
      )
)

export default inject('selectionStore', 'uiStore')(
  observer(RegionAnalysisView)
)
